import {
  SlideAction,
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AssetRouteProvider } from '../../assets/assetRouteContext';
import { Issue } from '../../issues/components/issue';
import ActivityEditLabels from './activity-edit-label';
import { ActivityEditColumn } from './activityEditColumn';

export const ActivityEdit = () => {
  const { issueId = '', assetId } = useParams();
  const navigate = useNavigate();
  const [selectedLabels, setSelectedLabels] = useState<
    Array<{ id: string; name: string }> | undefined
  >(undefined);
  const [isLabelsPanelOpen, setIsLabelsPanelOpen] = useState(false);
  const backGuardRef = useRef<((onProceed: () => void, onCancel?: () => void) => void) | null>(null);

  const backButtonGuard = (): Promise<boolean> => {
    if (isLabelsPanelOpen) {
      setIsLabelsPanelOpen(false);
      return Promise.resolve(false);
    }
    return new Promise<boolean>((resolve) => {
      if (!backGuardRef.current) {
        resolve(true);
        return;
      }
      backGuardRef.current(
        () => resolve(true),
        () => resolve(false)
      );
    });
  };

  const leftColumn = {
    title: 'activities.detail.title',
    showHeader: false,
    showBackButton: false,
    disableScroll: true,
    mainComponent: (
      <AssetRouteProvider value={{
        basePath: `/activities/${issueId}`,
        listPath: '/activities',
        isWorkspaceMode: false,
        issueId,
      }}>
        <Issue isComingFromActivities onBackPressGuard={backButtonGuard} showAssetLink={!assetId} />
      </AssetRouteProvider>
    ),
  };

  const rightColumn = {
    title: 'issue.menu.edit',
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    backButtonGuard,
    onBackButtonPress: () => navigate('..', { relative: 'path', state: { skipAutoSelect: true } }),
    mainComponent: (
      <ActivityEditColumn
        selectedLabels={selectedLabels}
        onLabelsChange={setSelectedLabels}
        backGuardRef={backGuardRef}
        onOpenLabelsPanel={() => setIsLabelsPanelOpen(true)}
      />
    ),
    disableScroll: true,
  };

  const thirdColumn = isLabelsPanelOpen
    ? {
        title: 'issue.new.labels',
        mainComponent: (
          <ActivityEditLabels
            issueId={issueId}
            selectedLabels={selectedLabels ?? []}
            onLabelsChange={setSelectedLabels}
          />
        ),
        showBackButton: true,
        onBackButtonPress: () => setIsLabelsPanelOpen(false),
        disableScroll: true,
      }
    : undefined;

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      thirdColumn={thirdColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
